import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

const newRelicOptions = {
  init: {
    distributed_tracing: {
      enabled: true,
      cors_use_newrelic_header: true,
      cors_use_tracecontext_headers: true,
      allowed_origins: [
        import.meta.env.VITE_APP_onBackstageAPI,
        import.meta.env.VITE_APP_onProductsAPI,
        import.meta.env.VITE_APP_onBackstage,
        import.meta.env.VITE_APP_onForce,
      ],
    },
    privacy: {
      cookies_enabled: false,
    },
  },
  info: {
    beacon: import.meta.env.VITE_APP_newRelicBeacon,
    errorBeacon: import.meta.env.VITE_APP_newRelicBeacon,
    licenseKey: import.meta.env.VITE_APP_newRelicLicenseKey,
    applicationID: import.meta.env.VITE_APP_newRelicApplicationID,
    sa: 1,
  },
  loader_config: {
    accountID: import.meta.env.VITE_APP_newRelicAccountID,
    trustKey: import.meta.env.VITE_APP_newRelicAccountID,
    agentID: import.meta.env.VITE_APP_newRelicApplicationID,
    licenseKey: import.meta.env.VITE_APP_newRelicLicenseKey,
    applicationID: import.meta.env.VITE_APP_newRelicApplicationID,
  },
};

export const newRelicAgent = new BrowserAgent(newRelicOptions);
